import React from 'react';
import { FiExternalLink } from 'react-icons/fi';
import { FiCopy } from 'react-icons/fi';
import AppModal from '../../common/AppModal';
import { toast } from 'react-toastify';
import services from '../../services';

const AddUser = ({ show, onHide, authUrl, updateAuthEmail, setAuthUrlData, authUrlData, setIsLoading, clientId }) => {

  const truncateUrl = (url, maxLength = 50) => {
    if (!url) return '';
    if (url.length <= maxLength) return url;
    return url.slice(0, maxLength) + '...';
  };

  const handleCopy = async (id) => {
    setIsLoading(true);
    try {
      const response = await services.email.updateAuthEmail(id);
      const url = response?.data?.authUrl;
      if (url) {
        if (!navigator.clipboard) {
          try {
            const textarea = document.createElement('textarea');
            textarea.value = url;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
            toast.success('Full URL copied to clipboard!');
          } catch (err) {
            console.error('Fallback copy failed:', err);
            toast.error('Failed to copy URL. Please copy manually.');
          }
          return;
        }
        navigator.clipboard.writeText(url)
          .then(() => { toast.success('Full URL copied to clipboard!'); })
          .catch((err) => {
            console.error('Clipboard API failed:', err);
            try {
              const textarea = document.createElement('textarea');
              textarea.value = url;
              document.body.appendChild(textarea);
              textarea.select();
              document.execCommand('copy');
              document.body.removeChild(textarea);
              toast.success('Full URL copied to clipboard!');
            } catch (fallbackErr) {
              console.error('Fallback copy failed:', fallbackErr);
              toast.error('Failed to copy URL. Please copy manually.');
            }
          });
      }
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpen = async (client_id) => {
    setIsLoading(true);
    try {
      const response = await services.email.updateAuthEmail(client_id);
      const openUrl = response?.data?.authUrl;
      if (openUrl) {
        const width = 500;
        const height = 400;
        const left = window.screen.width / 2 - width / 2;
        const top = window.screen.height / 3 - height / 2;
        window.open(
          openUrl,
          'Email Authorization',
          `width=${width},height=${height},top=${top},left=${left}`
        );
      }
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  // When clientId is set (row-level "Sync Account"), filter to that credential.
  // When null (footer "+ Sync New Gmail"), show all credentials.
  const filteredAuthData = clientId
    ? authUrlData?.filter((item) => item.client_id === clientId)
    : authUrlData;

  return (
    <AppModal
      show={show}
      onClose={onHide}
      icon={<FiExternalLink size={18} color="#fff" />}
      title="Authorize Account"
      subtitle="Open the URL below to grant access"
      maxWidth="560px"
    >
      {filteredAuthData && filteredAuthData.length > 0 ? (
        <div className="eauth-table-wrap">
          <table className="eauth-table">
            <thead>
              <tr>
                <th>Project ID</th>
                <th>Client ID</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredAuthData.map((item, index) => (
                <tr key={index}>
                  <td>{item.project_id || 'N/A'}</td>
                  <td>
                    {item.client_id
                      ? item.client_id.length > 15
                        ? `${item.client_id.substring(0, 15)}...`
                        : item.client_id
                      : 'N/A'}
                  </td>
                  <td>
                    <div className="eauth-table-actions">
                      <button
                        className="eauth-btn-copy"
                        onClick={() => handleCopy(item.client_id)}
                        title="Copy URL to clipboard"
                      >
                        <FiCopy size={11} style={{ marginRight: 5, verticalAlign: 'middle' }} />
                        Copy URL
                      </button>
                      <button
                        className="eauth-btn-open"
                        onClick={() => handleOpen(item.client_id)}
                        title="Open URL in new window"
                      >
                        <FiExternalLink size={11} style={{ marginRight: 5, verticalAlign: 'middle' }} />
                        Open URL
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="eauth-empty">No authorization URL available.</div>
      )}
    </AppModal>
  );
};

export default AddUser;
